import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  OnDestroy,
  ElementRef,
  ViewChild,
  Renderer2,
} from '@angular/core';
import { RequestService } from '../service/request.service';
import { GetterService } from '../service/getter-service.service';
import {
  countRequiredExtraGroups,
  isRequiredExtraGroup,
  popupService,
  resolveExtraSelectionType,
} from './popup.service';
import { ApiService } from '../service/api.service';
import { Subscription } from 'rxjs';
import { PosthogService } from '../analytics/services/posthog.service';
import { ExtraSelectionType } from '../../Model/Product-Interfaces';
declare let fbq: any;

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss'],
})
export class PopupComponent implements OnInit, OnDestroy {
  /* isDiscountedItem: boolean = false; */
  MenuBuilder: boolean = false;
  showPopup: boolean = false;
  dineIn: boolean = false;
  eatIn: boolean = false;
  addedTocart: boolean = false;
  filteredProduct: any;
  filteredRecipe: any;
  renderedExtraList: any[] = [];
  renderExtralistChooseOnes: number;
  openForNonExtras: boolean;
  @ViewChild('description', { static: false }) description: ElementRef;
  @Output() closeExtrasModal = new EventEmitter<boolean>();
  @Output() addedToCart = new EventEmitter<any>();
  extraArray: any[] = [];
  quantity: any;
  recipeTotal = 0;
  extrasTotal = 0;

  extraArrayChooseOnes: number = 0;
  recipes: any;
  recipePrice: number = 0;
  selectedRecipeTitle: string = '';

  productTotal: any;
  productPrice: number = 0;
  /* Menu Builder */
  selectedOptionId: number = 0;
  selectedOptionsArray = [0];
  selectedOptionString: String = '0';
  menuBuilderRootId: any = 0;
  disableCartbtn: boolean = true;

  /* Dynamic styles */
  SelectedButtonColor = '#B8860B';
  SelectedButtonTextColor;

  RecipeOldPriceText: string = 'Before';
  RecipeNewPriceText: string = 'Now';
  ExtraOldPriceText: string = 'Was';
  ExtraNewPriceText: string = 'After';
  RecipeOldPriceTextColor: string = '#696868';
  ExtraOldPriceTextColor: string = '#696868';

  RecipeDiscountLabelBGColor: string = '#198754';
  RecipeDiscountLabelTextColor: string = 'white';

  ExtraDiscountLabelBGColor: string = '#85d4afff';
  ExtraDiscountLabelTextColor: string = 'black';

  PopupOnKgItems: boolean;
  webCusSub: Subscription;
  popupSub: Subscription;
  mergePopups: boolean;
  renderedMenuBuilder: any;
  showExtrasAfterMenuBuilder: boolean;
  addtoCartButtonText: string;
  limitReached: boolean;
  addToCartRemainingLimit: number;
  timeout: NodeJS.Timeout;

  /**
   * Menu-builder pick -> the option it was made from. A section can repeat an
   * option name (e.g. "DONATION" at several prices), so highLightItem matches
   * on the option itself rather than its Title. Kept beside extraArray, not in
   * it, because extraArray is saved to the cart as-is.
   */
  private menuBuilderPickSource = new WeakMap<object, any>();
  CurrencySymbol: string;
  isPromotionItem: boolean;
  PromotionItemId: number;

  constructor(
    public _requestService: RequestService,
    private _local: GetterService,
    private changeDetector: ChangeDetectorRef,
    private popupService: popupService,
    private apiService: ApiService,
    private renderer: Renderer2,
    private posthog: PosthogService
  ) {}

  ngOnDestroy(): void {
    this.webCusSub.unsubscribe();
    this.popupSub.unsubscribe();
  }

  ngOnInit(): void {
    this.getWebCustomer();
    this.setData();
  }

  setData() {
    this.popupSub = this.popupService.popUpData.subscribe((data) => {
      this.posthog.captureEvent('Data Received in Recipe Extras Popup', {
        data: data,
      });
      this.isPromotionItem = data.isPromotionItem;
      this.PromotionItemId = data.PromotionItemId;
      this.dineIn = data.dineIn;
      this.extraArrayChooseOnes = 0;
      this.showExtrasAfterMenuBuilder = false;
      this.addToCartRemainingLimit = 0;
      this.extraArray = [];
      if (data.quantity) {
        this.quantity = data.quantity;
      } else {
        this.quantity = 1;
      }
      this.recipeTotal = 0;
      this.extrasTotal = 0;
      this.recipePrice = 0;
      this.renderedExtraList = [];
      this.disableCartbtn = true;
      this.MenuBuilder = data.MenuBuilder;
      this.mergePopups = data.mergePopups;
      this.eatIn = data.eatIn;
      this.filteredProduct = data.filteredProduct;
      this.filteredRecipe = data.filteredRecipe;
      this.renderedExtraList = data.renderedExtraList;
      this.renderedMenuBuilder = data.renderedMenuBuilder;
      // how many `Single` groups must have a pick before "add to cart" unlocks;
      // resolved here from the group criteria rather than trusting each caller's count
      this.renderExtralistChooseOnes = countRequiredExtraGroups(
        this.renderedExtraList
      );
      this.openForNonExtras = data.openForNonExtras;

      // menu builder section ids aren't guaranteed to start at 0, use the actual first section's id as the root
      const menuBuilderList = this.mergePopups
        ? this.renderedMenuBuilder
        : this.MenuBuilder
          ? this.renderedExtraList
          : null;
      this.menuBuilderRootId = menuBuilderList?.length
        ? menuBuilderList[0].Id
        : 0;
      this.selectedOptionId = this.menuBuilderRootId;
      this.selectedOptionsArray = [this.menuBuilderRootId];
      this.selectedOptionString = String(this.menuBuilderRootId);

      this.recipeTotal = this.recipePrice = this.isPromotionItem
        ? 0
        : this.filteredRecipe
          ? this.filteredRecipe.RecipePrice
          : this.filteredProduct.ProductOldPrice;

      this.recipeTotal = this.isPromotionItem
        ? 0
        : this.recipeTotal * this.quantity;
      if (
        this.filteredProduct?.ProductUnits?.toLowerCase() == 'kg' &&
        this.PopupOnKgItems
      ) {
        this.quantity = '1.0';
        this.recipeTotal = this.recipePrice = this.isPromotionItem
          ? 0
          : (this.filteredRecipe
              ? this.filteredRecipe.RecipePrice
              : this.filteredProduct.ProductOldPrice) * this.quantity;
      }

      let existing = this._local.get('cartRecipeItems')
        ? JSON.parse(this._local.get('cartRecipeItems'))
        : [];
      this.limitReached = false;
      if (existing.length && this.filteredRecipe) {
        existing.forEach((val) => {
          if (
            val.RecipeId == this.filteredRecipe.RecipeId &&
            this.filteredRecipe.RecipeMaxBuyAllowed
          ) {
            this.addToCartRemainingLimit =
              this.filteredRecipe.RecipeMaxBuyAllowed - val.RecipeQuantity;
            if (val.RecipeQuantity >= this.filteredRecipe.RecipeMaxBuyAllowed) {
              this.limitReached = true;
            }
          }
        });
      }
      if (this.limitReached) {
        setTimeout(() => {
          this.limitReached = false;
        }, 2000);
        return;
      }

      if (
        !this.renderedExtraList.length &&
        !this.renderedMenuBuilder?.length &&
        !this.openForNonExtras
      ) {
        this.addToCart(
          this.filteredRecipe ? this.filteredRecipe : this.filteredProduct,
          this.filteredRecipe ? 'recipe' : 'product'
        );
      } else {
        this.showPopup = true;
        setTimeout(() => {
          if (!this.filteredProduct) return;
          this.renderer.setProperty(
            this.description.nativeElement,
            'innerHTML',
            this.filteredProduct?.ProductContent
          );
        }, 1);
      }
    });
  }

  getWebCustomer() {
    this.webCusSub = this.apiService.getWebcustomer$.subscribe((res) => {
      if (!res) {
        return;
      }
      this.PopupOnKgItems = res.TemplateData?.AdditionalDetail?.PopupOnKgItems;
      this.SelectedButtonColor =
        res.TemplateData.DynamicStyle.SecondaryColors.SelectedButtonColor;
      this.SelectedButtonTextColor =
        res.TemplateData.DynamicStyle.SecondaryColors.SelectedButtonTextColor;
      this.addtoCartButtonText =
        res.TemplateData.CheckoutButtonsText?.PopupAddtoCartButtonText;
      this.CurrencySymbol = res.TemplateData.CurrencySymbol || 'GBP';

      this.RecipeOldPriceText =
        res.TemplateData?.Menu?.DiscountedItemsSettings.Recipe.RecipeOldPriceText;

      this.RecipeNewPriceText =
        res.TemplateData?.Menu?.DiscountedItemsSettings.Recipe.RecipeNewPriceText;

      this.RecipeOldPriceTextColor =
        res.TemplateData?.Menu?.DiscountedItemsSettings.Recipe.RecipeOldPriceTextColor;

      this.RecipeDiscountLabelBGColor =
        res.TemplateData?.Menu?.DiscountedItemsSettings.Recipe.RecipeDiscountLabelBGColor;

      this.RecipeDiscountLabelTextColor =
        res.TemplateData?.Menu?.DiscountedItemsSettings.Recipe.RecipeDiscountLabelTextColor;

      this.ExtraOldPriceText =
        res.TemplateData?.Menu?.DiscountedItemsSettings.Extras.ExtraOldPriceText;

      this.ExtraNewPriceText =
        res.TemplateData?.Menu?.DiscountedItemsSettings.Extras.ExtraNewPriceText;

      this.ExtraOldPriceTextColor =
        res.TemplateData?.Menu?.DiscountedItemsSettings.Extras.ExtraOldPriceTextColor;

      this.ExtraDiscountLabelBGColor =
        res.TemplateData?.Menu?.DiscountedItemsSettings.Extras.ExtraDiscountLabelBGColor;

      this.ExtraDiscountLabelTextColor =
        res.TemplateData?.Menu?.DiscountedItemsSettings.Extras.ExtraDiscountLabelTextColor;
    });
  }

  addToCart(selectedItem: any, flag: any) {
    let data: any;
    let existing: any[] = [];
    switch (flag) {
      case 'recipe':
        data = {
          RecipeId: selectedItem.RecipeId,
          RecipeTitle: selectedItem.RecipeTitle,
          RecipePrice: this.recipePrice + this.extrasTotal,
          recipeTotal: this.recipeTotal,
          RecipeImage: selectedItem.RecipeImage,
          RecipeQuantity: this.quantity,
          IsDiscountedItem: selectedItem.isDiscountedItem,
          RecipeExtraObject: this.extraArray,
          socialDiscountItem: selectedItem.socialDiscountItem,
          ForDelivery: selectedItem?.ForDelivery,
          ForCollection: selectedItem?.ForCollection,
          ForDineIn: selectedItem?.ForDineIn,
          ForEatIn: selectedItem?.ForEatIn,
          RecipeMaxBuyAllowed: this.filteredRecipe.RecipeMaxBuyAllowed,
          CategoryTitle: selectedItem.CategoryTitle,
          CategoryId: selectedItem.FK_CategoryId_Recipes,

          RecipeOldPrice: this.filteredRecipe.RecipeOldPrice,
          RecipeDiscountType: this.filteredRecipe.RecipeDiscountType,
          RecipeDiscountAmount: this.filteredRecipe.RecipeDiscountAmount,
          isPromotionItem: this.isPromotionItem,
          PromotionItemId: this.PromotionItemId,
        };

        existing = JSON.parse(this._local.get('cartRecipeItems'));

        if (existing != null && existing.length != 0) {
          let match: boolean = false;
          if (
            !selectedItem.isDiscountedItem ||
            !selectedItem.socialDiscountItem
          ) {
            existing.forEach((val) => {
              if (val.socialDiscountItem) return;
              if (
                this.isPromotionItem
                  ? val.PromotionItemId == this.PromotionItemId &&
                    val.RecipeId == selectedItem.RecipeId
                  : val.RecipeId == selectedItem.RecipeId &&
                    !val.isPromotionItem
              ) {
                // same extras AND same extra quantities → bump the line; otherwise it's a new line
                if (
                  this._requestService.sameExtras(
                    val.RecipeExtraObject,
                    this.extraArray
                  )
                ) {
                  match = true;
                  val.RecipeQuantity = +val.RecipeQuantity + +this.quantity;
                  val.IsDiscountedItem = selectedItem.IsDiscountedItem;
                  val.recipeTotal =
                    +val.recipeTotal + val.RecipePrice * +this.quantity;
                }
              }
            });
          }

          if (this.isPromotionItem ? true : !match) {
            existing.push(data);
          }
          this._requestService.saveRecipeCartItems(existing);
        } else {
          var tmp_array = [];
          tmp_array.push(data);
          this._local.set('cartRecipeItems', JSON.stringify(tmp_array));
          this._requestService.saveRecipeCartItems(tmp_array);
        }
        break;
      case 'product':
        data = {
          ProductId: selectedItem.ProductId,
          ProductTitle: selectedItem.ProductTitle,
          ProductOldPrice: selectedItem.ProductOldPrice + this.extrasTotal,
          ProductNewPrice: selectedItem.ProductNewPrice,
          ProductTotal: this.recipeTotal,
          ProductImageUrl: selectedItem.ProductImageUrl,
          ProductUnits: selectedItem?.ProductUnits,
          IsDiscountedItem: selectedItem.isDiscountedItem,
          ProductQuantity: this.quantity,
          ProductExtraObject: this.extraArray,
          ForDelivery: selectedItem?.ForDelivery,
          ForCollection: selectedItem?.ForCollection,
        };
        existing = JSON.parse(this._local.get('cartProductItems'));
        if (existing != null && existing.length != 0) {
          let match: boolean = false;
          if (!selectedItem.isDiscountedItem) {
            existing.forEach((val) => {
              if (val.ProductId == selectedItem.ProductId) {
                if (
                  this._requestService.sameExtras(
                    val.ProductExtraObject,
                    this.extraArray
                  )
                ) {
                  // kg quantities arrive as strings ('1.0'); never concatenate
                  val.ProductTotal =
                    +val.ProductTotal + this.recipePrice * +this.quantity;
                  val.ProductQuantity = +val.ProductQuantity + +this.quantity;
                  match = true;
                }
              }
            });
          }
          if (!match) {
            existing.push(data);
          }
          this._requestService.saveProductCartItems(existing);
        } else {
          var tmp_array = [];
          tmp_array.push(data);
          this._local.set('cartProductItems', JSON.stringify(tmp_array));
          this._requestService.saveProductCartItems(tmp_array);
        }
        break;
    }
    this.changeDetector.detectChanges();
    this.extraArray = [];
    this.selectedRecipeTitle = this.filteredRecipe
      ? selectedItem.RecipeTitle
      : selectedItem.ProductTitle;
    this.addedTocart = false;
    this.popupService.addedToCartSuccessful.next(data);

    // products come through as filteredProduct; filteredRecipe is null then and
    // this line used to throw, leaving the popup open after a successful add
    if (this.filteredRecipe) this.filteredRecipe.RecipeQuantity = this.quantity;

    this.posthog.captureEvent('Item_Added_to_cart_Successfully', {
      RecipeId: data.RecipeId,
      RecipeTitle: data.RecipeTitle,
      Category: data.CategoryTitle,
      Unit_price: data.RecipePrice,
      Quantity: data.RecipeQuantity,
    });

    if (typeof fbq !== 'undefined') {
      fbq('track', 'Add to cart', { item: selectedItem.RecipeTitle });
    }

    this.changeDetector.detectChanges();
    this.showPopup = false;
    this.addedTocart = true;

    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.addedTocart = false;
    }, 1300);

    if (!!this._local.getSessionItem('orderId')) {
      this._local.setSessionItem('amended', true);
    }
  }

  quantityControl(flag) {
    if (flag == '+') {
      this.quantity = this.quantity + 1;
    } else {
      if (this.quantity !== 1) {
        this.quantity = this.quantity - 1;
      }
    }
    this.updateExtrasTotals();
  }

  /* ---------------------------------------------------------------- */
  /* Extras group selection criteria                                   */
  /*   Single         – radio, exactly one, quantity 1, required       */
  /*   Optional       – radio, one option, quantity 1, not required     */
  /*   SelectOptional – checkboxes, any number, quantity 1 each, capped */
  /*   Multiple       – +/- quantity per option (capped)                */
  /* ---------------------------------------------------------------- */

  /** Criteria of an extras group – the template picks radio vs. quantity controls on this */
  getSelectionType(extra: any): ExtraSelectionType {
    return resolveExtraSelectionType(extra);
  }

  /** Rendered group an option belongs to (options carry their group name in `Key`) */
  private findRenderedGroup(key: string): any {
    return this.renderedExtraList?.find((group) => group?.Key == key);
  }

  /** Menu-builder picks sit in `extraArray` next to regular extras and carry a `redirection` */
  private isMenuBuilderSelection(val: any): boolean {
    return val?.redirection !== undefined && val?.redirection !== null;
  }

  /** Whether an option is currently picked (drives the radio `checked` state) */
  isExtraSelected(item: any): boolean {
    return this.extraArray.indexOf(item) >= 0;
  }

  /**
   * Option clicked in a regular extras group. `extra` is the group the option
   * belongs to; the group's selection criteria decides what happens.
   */
  selectExtra(item, recipe_price, extra?, event?: Event) {
    const group = extra ?? this.findRenderedGroup(item?.Key);
    const selectionType = this.getSelectionType(group);

    this.recipePrice = recipe_price;
    if (Number.isNaN(this.recipeTotal)) {
      this.recipeTotal = 0;
    }

    if (selectionType === 'Multiple') {
      this.incrementExtra(item, group);
    } else if (selectionType === 'SelectOptional') {
      if (!this.toggleOptionalExtra(item, group)) {
        // the browser has already ticked the box – undo it, the group is at its maxQuantity
        event?.preventDefault();
      }
    } else {
      // Single / Optional hold one option per group – drop the group's previous pick
      this.extraArray = this.extraArray.filter((val) => {
        if (this.isMenuBuilderSelection(val) || val.Key != item.Key) {
          return true;
        }
        val.Quantity = 0;
        return false;
      });
      item.Quantity = 1;
      this.extraArray.push(item);
    }

    this.updateExtrasTotals();
  }

  /** Number of options currently ticked in a group (menu-builder picks excluded) */
  private countSelectedInGroup(group: any): number {
    return this.extraArray.filter(
      (val) => !this.isMenuBuilderSelection(val) && val.Key == group?.Key
    ).length;
  }

  /** A SelectOptional group has reached its `maxQuantity`; unticked options are disabled */
  isExtraGroupFull(extra: any, item?: any): boolean {
    if (this.getSelectionType(extra) !== 'SelectOptional') return false;
    if (item && this.isExtraSelected(item)) return false;
    const maxQuantity = Number(extra?.maxQuantity);
    if (!(Number.isFinite(maxQuantity) && maxQuantity > 0)) return false;
    return this.countSelectedInGroup(extra) >= maxQuantity;
  }

  /**
   * Checkbox of a SelectOptional group – any number of options, quantity 1 each,
   * capped by the group's `maxQuantity`. Returns false when the tick was refused.
   */
  private toggleOptionalExtra(item: any, group: any): boolean {
    const index = this.extraArray.indexOf(item);
    if (index >= 0) {
      item.Quantity = 0;
      this.extraArray.splice(index, 1);
      return true;
    }

    if (this.isExtraGroupFull(group)) return false;

    item.Quantity = 1;
    this.extraArray.push(item);
    return true;
  }

  /** "+" on an option of a Multiple group – respects the group's `maxQuantity` and the per-option cap of 9 */
  private incrementExtra(item: any, group: any) {
    const maxQuantity = Number(group?.maxQuantity);
    if (Number.isFinite(maxQuantity) && maxQuantity > 0) {
      const groupQuantity = this.extraArray
        .filter(
          (val) => !this.isMenuBuilderSelection(val) && val.Key == item.Key
        )
        .reduce((sum, val) => sum + (Number(val.Quantity) || 0), 0);
      if (groupQuantity >= maxQuantity) return;
    }

    if (item.Quantity >= 9) return;

    item.Quantity = (Number(item.Quantity) || 0) + 1;
    if (!this.isExtraSelected(item)) {
      this.extraArray.push(item);
    }
  }

  /** "-" on an option of a Multiple group */
  multipleExtrasQuantity(item: any) {
    if (!(item.Quantity > 0)) return;

    item.Quantity -= 1;
    if (item.Quantity <= 0) {
      item.Quantity = 0;
      const index = this.extraArray.indexOf(item);
      if (index >= 0) {
        this.extraArray.splice(index, 1);
      }
    }
    this.updateExtrasTotals();
  }

  /** Recomputes extras subtotal, the popup total and how many required groups have a pick */
  private updateExtrasTotals() {
    this.extrasTotal = this.extraArray.reduce(
      (sum, val) => sum + val.Price * val.Quantity,
      0
    );
    this.extraArrayChooseOnes = this.countSelectedRequiredGroups();
    this.recipeTotal = this.isPromotionItem
      ? 0
      : this.recipePrice * this.quantity + this.extrasTotal * this.quantity;
  }

  /** Number of `Single` groups that currently have a pick (compared with `renderExtralistChooseOnes`) */
  private countSelectedRequiredGroups(): number {
    const selectedGroupKeys = new Set<string>();
    this.extraArray.forEach((val) => {
      if (this.isMenuBuilderSelection(val)) return;
      const group = this.findRenderedGroup(val.Key);
      if (group && isRequiredExtraGroup(group)) {
        selectedGroupKeys.add(val.Key);
      }
    });
    return selectedGroupKeys.size;
  }

  productQuantityControl(flag) {
    if (flag == '+') {
      this.quantity = this.quantity + 1;
      this.productTotal += this.productPrice;
    } else {
      if (this.quantity !== 1) {
        this.quantity = this.quantity - 1;
        this.productTotal -= this.productPrice;
      }
    }
  }

  selectProductExtra(item, product_price) {
    this.productPrice = product_price;
    if (Number.isNaN(this.productTotal)) {
      this.productTotal = 0;
    }

    let indexFlag = 0;

    if (this.extraArray.length != 0) {
      this.extraArray.forEach((val) => {
        if (val.Key == item.Key) {
          if (item.Price != 0) {
            this.productTotal -= val.Price * this.quantity;
          }

          this.extraArray.splice(this.extraArray.indexOf(val), 1);
          indexFlag = 1;
        }
      });

      if (indexFlag == 1) {
        if (item.Price != 0) {
          this.productTotal += item.Price * this.quantity;
        }
        this.extraArray.push(item);
      } else {
        if (item.Price != 0) {
          this.productTotal += item.Price * this.quantity;
        }
        this.extraArray.push(item);
      }
    } else {
      if (item.Price != 0) {
        this.productTotal += item.Price * this.quantity;
      }
      this.extraArray.push(item);
    }
    let sum: number = 0;
    this.extraArray.forEach((val) => {
      sum += val.Price;
    });
    this.productPrice += sum;
  }

  closeModel() {
    this.showPopup = false;
    this.closeExtrasModal.emit(false);
    this.posthog.captureEvent('Recipe Extras Popup Closed');
  }

  openNextOption(extra, item) {
    this.extraArrayChooseOnes = 0;
    this.disableCartbtn = true;

    this.renderedExtraList?.forEach((e) => {
      if (e.extras)
        e.extras.forEach((ex) => {
          ex.Quantity = 0;
        });
    });

    let newExtra: any = {
      Image: item.Img,
      Key: 'Choose One',
      Price: item.Price,
      Quantity: 1,
      Title: item.Item,
      cat: extra.Title,
      redirection: item.Redirection,
      Id: extra.Id,

      RecipeOldPrice: item.RecipeOldPrice,
      RecipeDiscountType: item.RecipeDiscountType,
      RecipeDiscountAmount: item.RecipeDiscountAmount,
    };
    this.extraArray.forEach((val, index, array) => {
      if (val.Id == newExtra.Id) {
        array.splice(this.extraArray.indexOf(val), array.length);
      }
    });
    this.extraArray.push(newExtra);
    this.menuBuilderPickSource.set(newExtra, item);

    this.selectedOptionsArray = [this.menuBuilderRootId];
    this.extraArray.forEach((value) => {
      if (value.redirection !== -1) {
        this.selectedOptionsArray.push(value.redirection);
        this.showExtrasAfterMenuBuilder = false;
      }
      if (value.redirection == -1) {
        this.disableCartbtn = false;
        this.showExtrasAfterMenuBuilder = true;
      }
    });
    this.openCategory(item.Redirection);
    this.getMenuBuilderTotal();
    document.getElementById(extra.Id.toString())?.scrollIntoView();
  }

  highLightItem(extraId, item): boolean {
    var result = false;
    this.extraArray.forEach((val) => {
      if (val.Id != extraId) return;
      const source = this.menuBuilderPickSource.get(val);
      // the option it was picked from; Title only for a pick with no source
      if (source ? source === item : val.Title == item.Item) {
        result = true;
      }
    });
    return result;
  }

  highLightCat(Id): boolean {
    var result = false;
    this.extraArray.forEach((val) => {
      if (val.Id == Id) {
        result = true;
      }
    });
    return result;
  }

  itemTitleReplace(extra) {
    var result = '';
    this.extraArray.forEach((val) => {
      if (val.Id == extra.Id) {
        result = val.Title;
      }
    });
    return result;
  }

  menuBuilderQuantity(flag) {
    if (flag == '+') {
      this.quantity = this.quantity + 1;
    } else {
      if (this.quantity !== 1) {
        this.quantity = this.quantity - 1;
      }
    }
    this.getMenuBuilderTotal();
  }

  openCategory(Id) {
    this.selectedOptionId = Id;
  }

  getMenuBuilderTotal() {
    this.updateExtrasTotals();
  }

  kgQuantity() {
    this.updateExtrasTotals();
  }

  stopPropagation(event: MouseEvent) {
    event.stopPropagation();
  }
}
